/**
 * Header for Bryntum demos
 */

import React, { Component, Fragment, ReactNode } from 'react';
import { BryntumFullscreenButton } from './BryntumFullscreenButton';
import { BryntumButton } from './BryntumButton';

export type BryntumDemoHeaderProps = {
    children?: ReactNode | ReactNode[]
    title?: string
}

export class BryntumDemoHeader extends Component<BryntumDemoHeaderProps> {

    getLink(): string {
        const match = /(.*?\/)(frameworks\/.*?)\/build/.exec(document.location.href);
        return match ? `${match[1]}#example-${match[2].replace(/\//gm, '-')}` : '#';
    }

    getTitle(): string {
        return this.props.title || document.title.split(' - ')[1] || document.title;
    }

    shouldComponentUpdate(nextProps: Readonly<BryntumDemoHeaderProps>): boolean {
        return nextProps.title !== this.props.title;
    }

    render(): ReactNode {
        return (
            <Fragment>
                <header className="demo-header">
                    <div id="title-container">
                        <a id="title" href={this.getLink()}>
                            <h1>{this.getTitle()}</h1>
                        </a>
                    </div>
                    {this.props.children}
                    <BryntumButton
                        text="Download Trial"
                        href="https://bryntum.com/download/?product=scheduler"
                        cls="b-green b-raised"
                    />
                    <BryntumFullscreenButton />
                </header>
            </Fragment>
        );
    }
}
